"use client";
import { jsx as n } from "react/jsx-runtime";
import { css as l } from "@emotion/react";
import p from "@emotion/styled";
import { ICON_COLORS as a } from "../../tokens/icon-colors/IconColors.js";
import { ICON_SIZES as e } from "../../tokens/icon-sizes/IconSizes.js";
import { ICONS as d } from "../../tokens/icons/Icons.js";
import { forwardRef as f } from "react";
const t = f(
  ({ feColor: o = "gray", feIcon: r, feSize: i = "md", ...s }, c) => {
    const m = d[r];
    return /* @__PURE__ */ n(
      I,
      {
        ...s,
        "aria-hidden": !0,
        "data-comp": "icon",
        feColor: o,
        feSize: i,
        ref: c,
        children: /* @__PURE__ */ n(m, {})
      }
    );
  }
);
t.displayName = "Icon";
const N = t, I = p.span(({ feColor: o, feSize: r }) => {
  if (!o || !r)
    throw new Error("Style error");
  return l`
		block-size: ${e[r]};
		color: ${a[o]};
		display: inline-flex;
		flex-shrink: 0; /* Prevents shrink when flex-child */
		inline-size: ${e[r]};
		pointer-events: none;
		user-select: none;
	`;
});
export {
  N as default
};
